import { DeleteIcon, PhoneIcon } from "@chakra-ui/icons";
import { Box, Grid, IconButton, Text } from "@chakra-ui/react";
import { slimScroll } from "chakra/theme";
import { SendIcon2 } from "components/vectors/send-icon";
import { useAttendanceContext } from "contexts/attendance-context";
import { useEffect, useRef, useState } from "react";
import { FaMicrophone } from "react-icons/fa";
import { Dropdown } from "components/dropdown";
import api from "api/api";
import { ChatStatus } from "..";
//@ts-ignore
import MicRecorder from "mic-recorder-to-mp3";
import { PauseIcon } from "components/vectors/pause-icon";
import { PlayIcon } from "components/vectors/play-icon";
import { Toast } from "components/toast";
import { WhatsAppMessagesApi } from "components/atendimentos-components/whatsapp-attendances/components/whats-app-chat/hooks/use-whats-app-session-controls/ws-messages-api";
import { UseWebSocketProps } from "components/atendimentos-components/use-init-web-socket/types";

export interface WhatsAppSession {
  id: number;
  nome: string;
  whatsappSessionId: string;
  customerCodigoNova: string;
  customerName: string;
  customerId: number;
  ativoVendeAI: boolean;
  type: string;
}

let audioRecorder: any = {};
let audioParts: Blob[] = [];

export function ChatInput({
  phone,
  chatStatus,
  wsSession,
}: {
  chatStatus: ChatStatus;
  phone: string | null;
  wsSession: UseWebSocketProps;
}) {
  const { formControl, dispatch, isReadOnly } = useAttendanceContext();
  const [whatsAppPhones, setWhatsAppPhones] = useState<WhatsAppSession[]>([]);
  const [loadingPhones, setLoadingPhones] = useState(false);
  const textBox = useRef<HTMLDivElement>(null);
  const [messageBody, setMessageBody] = useState("");
  const [isUsingAudio, setIsUsingAudio] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const whatsAppApi = WhatsAppMessagesApi({ wsSession });
  const isDisabled = chatStatus !== "authenticated" || !phone || isReadOnly;
  const isDropdownDisabled = isReadOnly;

  const clearChat = () => {
    textBox.current!.textContent = "";
    setMessageBody("");
  };

  const getPhones = async () => {
    setLoadingPhones(true);
    try {
      const { data } = await api.get("/whatsapp-sessions");
      setWhatsAppPhones(data);
    } catch (e: any) {
    } finally {
      setLoadingPhones(false);
    }
  };

  const changeWhatsAppSession = async (id: string, option: WhatsAppSession) => {
    setLoadingPhones(true);
    try {
      const res = await api.get(
        `/atendimentos/update-whatsapp-session/${formControl.values.id}/${id}`
      );
      dispatch({
        type: "changeFieldWithInitial",
        payload: { fieldName: "whatsAppSession", data: option },
      });
    } catch (e: any) {
      Toast({
        title: "Não foi possível carregar os telefones whatsapp.",
        status: "error",
      });
    } finally {
      setLoadingPhones(false);
    }
  };
  // AUDIO CONTROLS
  const startAudio = async () => {
    try {
      audioRecorder = new MicRecorder({ bitRate: 64 });
      await audioRecorder.start();
      setIsUsingAudio(true);
    } catch (e) {
      Toast({
        title: "Erro ao iniciar audio",
        status: "error",
      });
      console.error(e);
    }
  };

  const stopAudio = async ({
    finalize = true,
  }: { finalize?: boolean } = {}) => {
    try {
      const audio = await audioRecorder.stop();
      const [mp3Buffer, mp3Blob]: [Buffer[], Blob] = await audio.getMp3();
      let currentAudio: Blob;
      if (audioParts.length) {
        currentAudio = new Blob([...audioParts, mp3Blob]);
        audioParts = [];
      } else {
        currentAudio = new Blob(mp3Buffer);
        audioParts = [];
      }
      if (finalize) setIsUsingAudio(false);
      return { audio: currentAudio };
    } catch (e) {
      console.error(e);
      return { audio: null };
    }
  };

  const pauseAudio = async () => {
    try {
      const { audio } = await stopAudio({ finalize: false });
      setIsPaused(true);
      if (!audio) return;
      audioParts.push(audio);
    } catch (e) {
      console.error(e);
    }
  };

  const playAudio = async () => {
    try {
      await startAudio();
      setIsPaused(false);
    } catch (e) {}
  };

  const deleteAudio = async () => {
    try {
      const { audio } = await stopAudio({ finalize: true });
      audioParts = [];
      setIsPaused(false);
    } catch (e) {}
  };
  // FIM AUDIO CONTROLS

  useEffect(() => {
    getPhones();
  }, []);

  useEffect(() => {
    if (chatStatus === "not-authenticated") {
      clearChat();
    }
  }, [chatStatus]);

  return (
    <>
      <Grid
        w="97%"
        templateColumns={isUsingAudio ? "auto 40px 40px 40px" : "auto 40px"}
        gap="10px"
        flexDir="column"
        alignItems="stretch"
        pt="0px"
        width="97%"
        mx="auto"
      >
        <Dropdown
          options={whatsAppPhones}
          onChange={changeWhatsAppSession}
          value={formControl.values.whatsAppSession?.id}
          leftIcon={<PhoneIcon />}
          borderRadius="5px 5px 0px 0px"
          optionValue="id"
          optionLabel="nome"
          bg="#076058"
          _hover={{ bg: "#00a884" }}
          aria-label=""
          h="41px"
          isLoading={loadingPhones}
          // loadingText="Carregando"
          placeholder="Selecione um telefone"
          _loading={{
            _hover: { bg: "#076058" },
            opacity: 0.5,
            cursor: "not-allowed",
          }}
          color="#fff"
          _disabled={{
            _hover: { bg: "#076058" },
            opacity: 0.5,
            cursor: "not-allowed",
          }}
          width="100%"
          justifyContent="flex-start"
          isDisabled={isDropdownDisabled}
        >
          <Text mr="auto">
            {formControl.values.whatsAppSession?.nome
              ? formControl.values.whatsAppSession?.nome
              : "Selecione um telefone"}
          </Text>
        </Dropdown>
      </Grid>

      <Grid
        w="97%"
        mx="auto"
        templateColumns={isUsingAudio ? "auto 40px 40px 40px" : "auto 40px"}
        gap="10px"
        pb="8px"
        borderRadius="10"
      >
        <Box overflow="hidden" bg={"#fff"} borderRadius="0px 0px 20px 20px">
          <Box
            ref={textBox}
            p="10px 15px"
            minH="40px"
            fontSize="14"
            css={slimScroll}
            overflow="auto"
            onKeyUp={(e) => {
              const { textContent } = e.currentTarget;
              const value = textContent || "";
              setMessageBody(value);
              if (value === "") clearChat();
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                whatsAppApi.sendText({ body: value });
                clearChat();
              }
            }}
            onKeyDown={(e) =>
              e.key === "Enter" && !e.shiftKey ? e.preventDefault() : undefined
            }
            whiteSpace="pre-wrap"
            _focus={{ border: 0, outline: "none" }}
            pos="relative"
            role="textbox"
            cursor={!isDisabled ? undefined : "not-allowed"}
            opacity={!isDisabled ? 0.5 : 1}
            _empty={{
              _hover: { cursor: "text" },
              _before: {
                content:
                  chatStatus === "authenticated"
                    ? !phone
                      ? '"Insira o telefone WhatsApp do contato"'
                      : '"Digite uma mensagem"'
                    : '"Sessão whatsapp não autenticada"',
              },
            }}
            maxH="132px"
            contentEditable={!isDisabled}
          />
        </Box>
        {isUsingAudio ? (
          <>
            <IconButton
              mt="auto"
              icon={<DeleteIcon />}
              borderRadius="full"
              bg="#076058"
              w="40px"
              _hover={{ bg: "#00a884" }}
              aria-label=""
              onClick={deleteAudio}
              _disabled={{
                _hover: { bg: "#076058" },
                opacity: 0.5,
                cursor: "not-allowed",
              }}
            />
            <IconButton
              mt="auto"
              icon={isPaused ? <PlayIcon color="#EB4E3D" /> : <PauseIcon />}
              borderRadius="full"
              bg="transparent"
              w="40px"
              _hover={{ bg: "transparent" }}
              aria-label=""
              color="#EB4E3D"
              border="3px solid #EB4E3D"
              onClick={isPaused ? playAudio : pauseAudio}
              _disabled={{
                _hover: { bg: "#076058" },
                opacity: 0.5,
                cursor: "not-allowed",
              }}
            />
          </>
        ) : null}
        <IconButton
          mt="auto"
          icon={
            messageBody.trim() ? (
              <SendIcon2 />
            ) : isUsingAudio ? (
              <SendIcon2 />
            ) : (
              <FaMicrophone />
            )
          }
          borderRadius="full"
          animation={isUsingAudio ? "recording 1.6s linear infinite" : ""}
          bg="#076058"
          w="40px"
          _hover={{ bg: "#00a884" }}
          aria-label=""
          onClick={async () => {
            if (messageBody.trim()) {
              whatsAppApi.sendText({ body: messageBody || "" });
              clearChat();
            } else {
              if (isUsingAudio) {
                const { audio } = await stopAudio({ finalize: true });
                if (audio) {
                  await whatsAppApi.sendAudio(audio);
                }
              } else startAudio();
            }
          }}
          isDisabled={isDisabled}
          _disabled={{
            _hover: { bg: "#076058" },
            opacity: 0.5,
            cursor: "not-allowed",
          }}
        />
      </Grid>
    </>
  );
}
